import React, { useState } from "react"
import PageHeader from "../../components/Ui/Page/PageHeader"
import CustomerOrderTable from "../../components/Customer/CustomerOrderTable"
import CustomerCheckoutSessionTable from "../../components/Customer/CustomerCheckoutSessionTable"
import DeleteCustomerOrders from "../../components/Customer/DeleteCustomerOrders"
import { useOutletContext } from "react-router"
import { CustomerOrders } from "../../classes/customer/CustomerOrders"
import { useSelector } from "react-redux"
import { customerSelect } from "lib/store/services/customer/customerSelector"
import { useLocation } from "react-router-dom"
import { Tab, TabList, TabPanel, Tabs } from "react-tabs"
import { WithAuth } from "../../components/Auth"
import { PermissionGroups } from "../../routes/constants"
import { FreeTrialBadge } from "./Customer.styled"

const SearchCustomer = () => {
  const customer = useSelector(customerSelect)
  const { state } = useLocation()
  const email = (state as { email: string })?.email

  const [searchString, setSearchString] = useState(email ?? customer.email)

  interface Context {
    customerOrders: CustomerOrders
  }

  const { customerOrders } = useOutletContext<Context>()

  return (
    <>
      <PageHeader
        title={"Customer overview"}
        description={"Search for customers using email address to see an overview of events."}
      >
        <WithAuth requiredGroups={PermissionGroups.orders.delete}>
          <DeleteCustomerOrders customerOrders={customerOrders} />
        </WithAuth>
      </PageHeader>
      <Tabs>
        <WithAuth configKey={"insightsEnabled"} requiredGroups={PermissionGroups.insights.read}>
          <TabList>
            <Tab>Orders {customer.orders && <b>({customer.orders.length})</b>}</Tab>
            <Tab>
              Checkout Insights{" "}
              {customer.checkouts.length > 0 && <b>({customer.checkouts.length})</b>}
              <FreeTrialBadge>Free trial</FreeTrialBadge>
            </Tab>
          </TabList>
        </WithAuth>
        <TabPanel>
          <CustomerOrderTable
            customerOrders={customerOrders}
            searchString={searchString}
            setSearchString={setSearchString}
            email={email}
          />
        </TabPanel>
        <TabPanel>
          <WithAuth configKey={"insightsEnabled"} requiredGroups={PermissionGroups.insights.read}>
            <CustomerCheckoutSessionTable
              checkouts={customer.checkouts}
              customerEmail={searchString}
              customerOrders={customerOrders}
              searchString={searchString}
              setSearchString={setSearchString}
              email={email}
            />
          </WithAuth>
        </TabPanel>
      </Tabs>
    </>
  )
}

export default SearchCustomer
